import { createStore, createLogger } from "vuex";

export const store: any = createStore({
  plugins: [createLogger()],
  state: {},
  mutations: {},
  actions: {}
});
